// Breakpoints for `breakpointClasses.ts` (ResizeObserver-based responsive
// system used by jobs list / detail — NOT the new job form).
export const twoColumnBreakpoint = 880;
export const threeColumnBreakpoint = 1200;

// Data-mount access modes — must match the values accepted by the backend
export const ACCESS_MODE_READ_ONLY = "ro";
export const ACCESS_MODE_READ_WRITE = "rw";
export type AccessMode =
  | typeof ACCESS_MODE_READ_ONLY
  | typeof ACCESS_MODE_READ_WRITE;
export const ACCESS_MODES: ReadonlySet<AccessMode> = new Set<AccessMode>([
  ACCESS_MODE_READ_ONLY,
  ACCESS_MODE_READ_WRITE,
]);
export function isAccessMode(s: string): s is AccessMode {
  return (ACCESS_MODES as ReadonlySet<string>).has(s);
}
